module.exports = __webpack_public_path__ + "img/bg01.eb5a21ec.png";